import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const DENY_USER = "DENY_USER";

export interface DenyUserAction extends Action {
  type: typeof DENY_USER;
  userId: string | number;
  organization: OrganizationKeyName;
}

export const denyUserAction = (
  organization: OrganizationKeyName,
  userId: string | number
): DenyUserAction => ({
  type: DENY_USER,
  userId,
  organization,
});
